import { render, staticRenderFns } from "./UptodateAbstract.vue?vue&type=template&id=3473a688&scoped=true"
import script from "./UptodateAbstract.vue?vue&type=script&lang=js"
export * from "./UptodateAbstract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473a688",
  null
  
)

export default component.exports